import api from './api';

export const historyDetail = (id, token) => {
    return async (dispatch) => {
        try {
            // Gọi API
            const response = await api.get('api/orders/'+id,
                {},
                {
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + token,
                },
            );
            dispatch({ type: 'DETAIL_SUCCESS', payload: response.data });
            // console.log(response);
        } catch (error) {
            dispatch({ type: 'DETAIL_FAILURE', payload: error.message });
        }
    };
};
